import styled from "styled-components";

const SocialStyleWrapper = styled.section`
  margin-bottom: 30px;

  .social-link-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 30px;
    row-gap: 20px;

    a {
      color: #ffffff;
      width: 60px;
      height: 60px;
      line-height: 60px;
      transition: 0.4s;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        img {
          opacity: 0.6;
        }
      }
    }
  }
  @media only screen and (max-width: 991px) {
    margin-bottom: 30px;
  }
  @media only screen and (max-width: 575px) {
    margin-bottom: 20px;
  }
`;

export default SocialStyleWrapper;
